const ZAIMY_POD_ZALOG = [
  "https://halvacard.ru/order/zaimy/pod-zalog-doli-v-kvartire/",
  "https://halvacard.ru/order/zaimy/pod-zalog-nedvizhimosti/",
  "https://halvacard.ru/order/zaimy/pod-zalog-nedvizhimosti-ekaterinburg/",
  "https://halvacard.ru/order/zaimy/pod-zalog-nedvizhimosti-krasnodar/",
  "https://halvacard.ru/order/zaimy/pod-zalog-nedvizhimosti-krasnoyarsk/",
  "https://halvacard.ru/order/zaimy/pod-zalog-nedvizhimosti-sochi/",
  "https://halvacard.ru/order/zaimy/pod-zalog-uchastka/",
  "https://halvacard.ru/order/zaimy/pod-zalog-nedvizhimosti-sankt-peterburg/",
]

const ZAIMY_SPECIAL_CONDITIONS = [
  "https://halvacard.ru/order/zaimy/bez-zaloga/",
  "https://halvacard.ru/order/zaimy/bez-kreditnogo-reitinga/",
  "https://halvacard.ru/order/zaimy/bez-otkaza/",
  "https://halvacard.ru/order/zaimy/bez-pasporta/",
  "https://halvacard.ru/order/zaimy/bez-podpisok-i-dop-uslug/",
  "https://halvacard.ru/order/zaimy/bez-posrednikov/",
  "https://halvacard.ru/order/zaimy/bez-proverki-kreditnoi-istorii/",
  "https://halvacard.ru/order/zaimy/bez-procentov/",
  "https://halvacard.ru/order/zaimy/bez-spravok/",
  "https://halvacard.ru/order/zaimy/bez-strahovki/",
  "https://halvacard.ru/order/zaimy/online-bez-snilsa/",
  "https://halvacard.ru/order/zaimy/ot-chastnogo-lica/",
  "https://halvacard.ru/order/zaimy/pensioneram/",
  "https://halvacard.ru/order/zaimy/po-pasportu/",
  "https://halvacard.ru/order/zaimy/pod-minimalnyi-procent/",
  "https://halvacard.ru/order/zaimy/pod-nizkii-procent/",
  "https://halvacard.ru/order/zaimy/s-bolshoi-kreditnoi-nagruzkoi/",
  "https://halvacard.ru/order/zaimy/s-vremennoi-registraciei/",
  "https://halvacard.ru/order/zaimy/s-plohoi-ki/",
  "https://halvacard.ru/order/zaimy/express-bez-procentov/",
  "https://halvacard.ru/order/zaimy/na-kartu-s-18-let/",
  "https://halvacard.ru/order/zaimy/cherez-gosuslugi/",
  "https://halvacard.ru/order/zaimy/kotorye-dayut-vsem/",
  "https://halvacard.ru/order/zaimy/kredity-i-yuridicheskim-licam/",
  "https://halvacard.ru/order/zaimy/bez-oficialnogo-trudoustroistva/",
]

const ZAIMY_BY_METHOD_OBTAINING = [
  "https://halvacard.ru/order/zaimy/v-banke/",
  "https://halvacard.ru/order/zaimy/na-virtualnuyu-kartu/",
  "https://halvacard.ru/order/zaimy/na-kartu-bez-otkaza/",
  "https://halvacard.ru/order/zaimy/na-kivi-koshelek/",
  "https://halvacard.ru/order/zaimy/na-kreditnuyu-kartu/",
  "https://halvacard.ru/order/zaimy/na-telefon-online/",
  "https://halvacard.ru/order/zaimy/po-telefonu-online/",
  "https://halvacard.ru/order/zaimy/cherez-prilozhenie/",
  "https://halvacard.ru/order/zaimy/nalichnymi/",
  "https://halvacard.ru/order/zaimy/kruglosutochnye/",
  "https://halvacard.ru/order/zaimy/momentalnyi/",
  "https://halvacard.ru/order/zaimy/momentalnyi-na-kartu/",
  "https://halvacard.ru/order/zaimy/express/",
  "https://halvacard.ru/order/zaimy/na-kivi-bez-pasporta/",
]

const ZAIMY_BY_MATURITY = [
  "https://halvacard.ru/order/zaimy/dolgosrochnye/",
  "https://halvacard.ru/order/zaimy/do-zarplaty/",
  "https://halvacard.ru/order/zaimy/na-1-god-bez-procentov/",
  "https://halvacard.ru/order/zaimy/na-30-dnej/",
  "https://halvacard.ru/order/zaimy/na-6-mesyacev/",
  "https://halvacard.ru/order/zaimy/na-den/",
  "https://halvacard.ru/order/zaimy/na-krupnuyu-summu/",
  "https://halvacard.ru/order/zaimy/dolgosrochnyi-s-prosrochkami/",
]

const map = new Map<string[], (url: string) => unknown>([
  [
    ZAIMY_POD_ZALOG,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Чем карта Халва выгоднее займа под залог?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "💡 Халва — это рассрочка без переплат, с удобным графиком платежей и без скрытых комиссий.",
          upvoteCount: 25,
        },
      },
    }),
  ],
  [
    ZAIMY_SPECIAL_CONDITIONS,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему Халва лучше займа на карту?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "💸 Лимит до 500 000 ₽\n💰 снятие наличных в рассрочку до 3 мес\n⚡ мгновенное оформление",
          upvoteCount: 36,
        },
      },
    }),
  ],
  [
    ZAIMY_BY_METHOD_OBTAINING,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему карта рассрочки выгоднее получения займа в МФО?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "📲 Оформление онлайн, 💰 снятие наличных в рассрочку до 3 месяцев, 💳 лимит до 500 000 ₽.",
          upvoteCount: 38,
        },
      },
    }),
  ],
  [
    ZAIMY_BY_MATURITY,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему рассрочка по карте Халва выгоднее займа?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "⏳ Рассрочка до 10 месяцев без процентов, 💵 удобный график платежей, 🛒 возможность оплачивать любые покупки",
          upvoteCount: 35,
        },
      },
    }),
  ],
])

export const typeQAPageZaimy = (url: string) => {
  const iterator = map.entries()

  let data = iterator.next()

  while (data.value) {
    const [urls, fn] = data.value

    if (urls.includes(url)) {
      return JSON.stringify(fn(url))
    }

    data = iterator.next()
  }

  // Дефолтный вариант
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "QAPage",
    mainEntity: {
      "@type": "Question",
      name: "Почему Халва лучше займа на карту?",
      url,
      answerCount: 1,
      acceptedAnswer: {
        "@type": "Answer",
        text: "💸 Лимит до 500 000 ₽\n💰 снятие наличных в рассрочку до 3 мес\n⚡ мгновенное оформление",
        upvoteCount: 36,
      },
    },
  })
}
